export default "__VITE_ASSET__ddff7fd8__"